(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/animations/huxflux.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/animations/huxflux.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.animations = svs.tur.ball.row.animations || {};
const Events = svs.tur.ball.constants;
class HuxFlux {
  start(_ref) {
    let row = _ref.row,
      _ref$random = _ref.random,
      random = _ref$random === void 0 ? false : _ref$random;
    let negativeDelay = 0,
      ballsToHuxFlux = [];
    const tl = gsap.timeline({
      onStart: () => {
        row.trigger(Events.HUXFLUX_STARTED);
      },
      onComplete: () => {
        row.trigger(Events.HUXFLUX_COMPLETED);
      }
    });
    ballsToHuxFlux = row.balls;
    if (random) {
      ballsToHuxFlux = _.shuffle(ballsToHuxFlux);
    }
    ballsToHuxFlux.forEach(ball => {
      if (ball._huxfluxToNumber !== undefined) {
        const tween = ball.huxflux();
        if (tween) {
          tl.add(tween, "-=".concat(negativeDelay));
          negativeDelay = tween.duration() - 0.2;
        }
      }
    });
    return tl;
  }
}
svs.tur.ball.row.animations.HuxFlux = new HuxFlux();

 })(window);